import React, { useState } from "react";
import useReactRouter from "use-react-router";
import { Breadcrumb, Form, Spinner, Button } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import { updateShop } from "../../../graphql/mutations";
import { useToasts } from "react-toast-notifications";
import { UPDATE_SHOP } from "../../../graphql/shop/mutation";
import useWindowDimensions from "../../../helpers/useWindowDimensions";
import { COLOR_APP, COLOR_TEXT } from "../../../constants";

export default function CommisionPage({
  closeModal,
  commisionDefault,
  noteDefault,
}) {
  const { history } = useReactRouter();
  const { addToast } = useToasts();

  const [preData, setPreData] = useState({
    commision: commisionDefault ?? "",
    note: noteDefault ?? "",
  });
  const { height, width } = useWindowDimensions();

  const shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

  const [updateCommisionShop, { loading: loadingUpdate }] =
    useMutation(UPDATE_SHOP);

  // update commission data for influencer
  const handleUpdateCommision = async (e) => {
    e.preventDefault();
    try {
      if (loadingUpdate) return;

      // console.log("dddddd----->",preData)
      // return ;

      const res = await updateCommisionShop({
        variables: {
          where: {
            id: shopId,
          },
          data: {
            commision: parseFloat(preData?.commision),
            note: preData?.note,
          },
        },
      });

      if (res) {
        setPreData({
          commision: "",
          note: "",
        });
        addToast("ກຳນົດສຳເລັດ!", {
          appearance: "success",
          autoDismiss: true,
        });
        closeModal();
      }

      // console.log("preData=----->", preData);
    } catch (error) {
      console.log("error ", error);
    }
  };

  return (
    <div>
      <h4>ກຳນົດຄ່າຄອມມິດຊັ່ນສຳຫລັບຮ້ານຂອງທ່ານ</h4>
      <div className="card-comision-page">
        <Form className="card-form" onSubmit={(e) => handleUpdateCommision(e)}>
          <Form.Group className="mb-3">
            <Form.Label>ຄ່າຄອມມິດຊັ່ນ </Form.Label>
            <Form.Control
              value={preData?.commision}
              onChange={(e) =>
                setPreData({
                  ...preData,
                  commision: e?.target?.value,
                })
              }
              type="text"
              placeholder="ປ້ອນຄ່າຄອມມິດຊັ່ນ"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>ລາຍລະອຽດ </Form.Label>
            <Form.Control
              value={preData?.note}
              onChange={(e) =>
                setPreData({
                  ...preData,
                  note: e?.target?.value,
                })
              }
              as="textarea"
              rows={3}
              placeholder="ປ້ອນລາຍລະອຽດ..."
            />
          </Form.Group>
          <div className="py-3">
            <Button type="submit">{
                loadingUpdate ? (
                  <>
                    <Spinner size="sm" /> ກຳລັງອັບແດບ
                  </>
                ) : (
                  "ບັນທຶກ"
                )
              }</Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
